import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from 'src/constants/index';
import './style.scss';

interface IProps {}

export class ErrorPage extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <div className="error-page">
        Error, sorry we have some problems <Link to={Routes.Search}>Return to home page</Link>
      </div>
    );
  }
}
